import { Container } from 'inversify';

import { IInversifyModule } from './types';

export abstract class InversifyContainer {
  protected static buildInversifyIOCContainer(
    args: Array<IInversifyModule['class']>,
  ): Container {
    const inversifyContainer = new Container();

    inversifyContainer.bind(Container).toConstantValue(inversifyContainer);

    for (const inversifyModule of args) {
      inversifyContainer.bind(inversifyModule).toSelf().inSingletonScope();
    }

    return inversifyContainer;
  }
}
